import {
  Dialog,
  Slide
} from "@material-ui/core";
import React from "react";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FormOnTask(props) {
  const {
    open,
    handleClose,
    urlGambar,
  } = props;

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        handleClose();
      }}
      maxWidth="lg"
      TransitionComponent={Transition}
    >
      <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
        {urlGambar?.picture ?
          urlGambar?.picture?.map((row) => {
            return <img
              onClick={handleClose}
              alt={`${row.url_gambar}`}
              src={`${row.url_gambar}`}
              style={{ height: "80vh", maxWidth: "100%", objectFit: 'scale-down', }}
              width="300px"
            />
          }) : ""}
      </Carousel>
    </Dialog>
  );
}
